import { createSelector } from 'reselect';
// import debug from 'debug';

import * as types from '../actions/tracking.types';

export const STORE_KEY = 'tracking';
export const selectTrackingState = state => state[STORE_KEY];
export const selectTracking = state => selectTrackingState(state).tracking;
export const selectTrackedPlayers = createSelector(
  selectTracking,
  tracking => Object.keys(tracking).map(id => Number(id)),
);

// const log = debug('huddle:store:reducers:tracking');

const INITIAL_STATE = {
  error: null,
  loading: true,
  tracking: {},
};

function gettingTracking(state) {
  return {
    ...state,
    loading: true,
  };
}

function trackingError(state, error) {
  return {
    ...state,
    loading: false,
    error,
  };
}

function gotTracking(state, { tracking }) {
  return { ...state,
    error: null,
    loading: false,
    tracking: tracking.reduce(
      (track, player) => {
        const id = player.player_id;
        const leagues = player.formulas
          .filter(f => f.formula_id !== null)
          .map(f => f.formula_id);
        const mode = leagues.length ? 'specific' : 'generic';

        return { ...track, [id]: { leagues, mode, player } };
      }, {}),
  };
}

function addedTracking(state, { id, leagues }) {
  const newTrack = { ...state.tracking };

  newTrack[id] = {
    leagues,
    mode: leagues.length ? 'specific' : 'generic',
  };

  return {
    ...state,
    error: null,
    loading: false,
    tracking: newTrack,
  };
}

function deletedTracking(state, { id }) {
  let newTrack = { ...state.tracking };
  delete newTrack[id];

  return {
    ...state,
    error: null,
    loading: false,
    tracking: newTrack,
  };
}

function deletedLeagueTracking(state, { id }) {
  const newTrack = { ...state.tracking };
  delete newTrack[id];

  return {
    ...state,
    error: null,
    loading: false,
    tracking: newTrack,
  };
}

function changedTracking(state, { id, leagues }) {
  return {
    ...state,
    error: null,
    loading: false,
    tracking: {
      ...state.tracking,
      [id]: {
        ...state.tracking[id],
        leagues,
        mode: leagues.length ? 'specific' : 'generic',
      },
    },
  };
}

function setPlayerData(state, { id, player }) {
  return {
    ...state,
    error: null,
    tracking: {
      ...state.tracking,
      [id]: {
        player: {
          player_id: id,
          ...player,
        },
        ...state.tracking[id],
      },
    },
  };
}

function trackingReducer(state = INITIAL_STATE, action = {}) {
  const { type, error, payload } = action;
  switch (type) {
    case types.TRACK_SET_PLAYER_DATA:
      return setPlayerData(state, payload);
    case types.TRACK_GET:
      return gettingTracking(state);
    case types.TRACK_GOT:
      return gotTracking(state, payload);
    case types.TRACK_ERROR:
    case types.TRACK_UPDATE_ERROR:
      return trackingError(state, error);
    case types.TRACK_ADD:
      return addedTracking(state, payload);
    case types.TRACK_DELETE:
      return deletedTracking(state, payload);
    case types.TRACK_DELETE_LEAGUE:
      return deletedLeagueTracking(state, payload);
    case types.TRACK_CHANGE:
      return changedTracking(state, payload);
    default:
      return state;
  }
}

export default trackingReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/tracking.js